<!-- 满减活动详情 -->
<template>
  <div class="full-reduction-component">
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '100%' }"
      duration="0.18"
      close-icon-position="top-left"
      @click-close-icon="close"
    >
      <!--v-if="show"  未点击联报入口，不初始化联报详情 -->
      <div class="jointPreferencesDetail" v-if="show">
        <!-- 标题 -->
        <h1 class="title">
          <div class="title-text">
            <img
              src="@/assets/img/components/wechatBinding/icon_close.png"
              @click="close()"
              alt=""
            />
            <span>满减优惠</span>
            <span class="empty-span"></span>
          </div>
        </h1>
        <van-list
          v-model="loading"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          @load="init"
        >
          <div class="course_info">
            <!-- 默认已选课程 -->
            <h2 class="course_info_title">当前课程</h2>
            <div class="defaultSelectCourse">
              <FullReductionCard
                v-if="defaultCourseInfo.productId"
                :courseInfo="defaultCourseInfo"
                @triggerSku="receiveSku"
                class="defaultSelectCourse"
              />
            </div>
            <!-- 可选课程列表 -->
            <h2 class="course_info_title">可选课程</h2>
            <div class="discount_info" v-if="activityData">
              <span class="discount-text">
                满减优惠，
                <template v-if="activityData.fullDiscountType === 3">
                  满{{ activityData.fullDiscountConditionList[0].fullAmount }}打{{
                    activityData.fullDiscountConditionList[0].discountRate
                  }}折
                </template>
                <template v-else-if="activityData.fullDiscountType === 2">
                  每满{{ activityData.fullDiscountConditionList[0].fullAmount }}减{{
                    activityData.fullDiscountConditionList[0].discountAmount
                  }}
                </template>
                <template v-else-if="activityData.fullDiscountType === 1">
                  <span
                    v-for="(item, index) in activityData.fullDiscountConditionList"
                    :key="index"
                  >
                    满{{ item.fullAmount }}减{{ item.discountAmount }}
                    <span v-if="activityData.fullDiscountConditionList.length - 1 !== index"
                      >，</span
                    >
                  </span>
                </template>
              </span>
            </div>
            <div class="course_list">
              <FullReductionCard
                v-for="(item, index) in courseList"
                :key="index"
                @triggerChecked="receiveCourse"
                @triggerSku="receiveSku"
                :courseInfo="item"
              />
            </div>
          </div>
        </van-list>
        <!-- 底部按钮 -->
        <!-- 联报与满减都不存在时不显示优惠 -->
        <footer
          class="foot"
          :class="{ 'foot-no-discount': !this.unionDiscountPrice && !this.fullDiscountPrice }"
        >
          <!-- 优惠描述 -->
          <div class="foot_discount_info">
            <div class="discount_content">
              <template v-if="this.unionDiscountPrice && this.fullDiscountPrice">
                <span>已享受满减，联报优惠</span
                ><b>￥{{ (this.unionDiscountPrice + this.fullDiscountPrice).toFixed(2) }}</b>
              </template>
              <template v-else-if="this.fullDiscountPrice">
                <span>已享受满减优惠</span><b>￥{{ this.fullDiscountPrice }}</b>
              </template>
              <template v-else-if="this.unionDiscountPrice">
                <span>已享受联报优惠</span><b>￥{{ this.unionDiscountPrice }}</b>
              </template>
            </div>
          </div>
          <!-- fix 按钮 -->
          <div class="foot_btn">
            <div class="foot_btn_left">
              <div class="price">
                <span>￥</span><b>{{ calculationPrice(totalPrice).b }}</b
                ><span>{{ calculationPrice(totalPrice).s }}</span>
              </div>
              <div class="num">
                <div v-if="selectCourse.length > 1">
                  已选<b>{{ selectCourse.length }}</b
                  >个
                </div>
                <span v-else>选购产品参与优惠活动吧～</span>
                <div class="secondSKillTips" v-show="skillFlag">
                  (秒杀课程不参与其他优惠)
                </div>
              </div>
            </div>
            <div class="foot_btn_right">
              <button @click="jumpBuy">
                {{ selectCourse.length === 1 ? '购买单科' : '满减购买' }}
              </button>
            </div>
          </div>
        </footer>
      </div>
    </van-popup>
    <commonLoading v-if="priceLoading" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { priceCount, setTokenFromCookie, gioPlatform } from '@/utils/tools';
// eslint-disable-next-line import/extensions
import FullReductionCard from '@/components/courseDetail/fullReduction/FullReductionCard';
import { reqPrice } from '@/api/pay/index';
import { reqProductRecommend } from '@/api/courseDetail/fullReduction/fullReduction';
// eslint-disable-next-line import/extensions
import commonLoading from '@/components/commonComponents/CommonLoading';

export default {
  components: {
    FullReductionCard,
    commonLoading,
  },

  data() {
    return {
      show: false,
      selectCourse: [], // 已勾的课程列表
      totalPrice: 0, // 应付总额
      unionDiscountPrice: 0, // 联报优惠
      actionType: 0, // 1登录后跳转订单页
      defaultCourseInfo: {}, // 默认产品的信息
      courseList: [],
      pageNum: 1,
      pageSize: 20,
      error: false,
      loading: false,
      finished: false,
      fullDiscountPrice: 0, // 满减优惠
      priceLoading: false, // 计算价格接口
      skillFlag: false, // 是否显示秒杀不参与优惠的文案
      gioList: [], // 用于gio埋点
    };
  },
  props: {
    // 默认选中的产品
    // eg: [{ productId: 604,skuId: 700}]
    defaultSelectCourse: {
      type: Array,
      default: () => [],
    },
    activityData: {
      type: Object,
      default: () => ({}),
    },
    allActivity: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState(['userInfo', 'courseSimpleData', 'productSku']),
  },
  watch: {
    show(status) {
      if (status) {
        this.initDefaultCourse();
        this.pageNum = 1;
        this.pageSize = 20;
        this.finished = false;
        this.loading = true;
        this.courseList = [];
        this.init();
      }
    },
  },
  mounted() {
    // console.log(this.activityData, 164);
  },
  methods: {
    async initDefaultCourse() {
      let skuName;
      JSON.parse(this.productSku.specJson).forEach((item) => {
        if (skuName) {
          skuName = `${skuName},${item.value}`;
        } else {
          skuName = item.value;
        }
      });
      const param = {
        productType: 2,
        productIdList: [this.defaultSelectCourse[0].productId],
      };
      const res = await reqProductRecommend(param);
      if (res.code === 0) {
        const course = res.data.data.filter(
          (item) => item.productId === this.defaultSelectCourse[0].productId,
        );
        // eslint-disable-next-line prefer-destructuring
        const skuInfo = course[0].recommendFullPromotionSkuRespList.find(
          (item) => item.productSkuId === this.productSku.productSkuId,
        );
        // eslint-disable-next-line no-shadow
        const skuName = [];
        JSON.parse(skuInfo.specJson).forEach((item) => {
          skuName.push(item.value);
        });
        const courseData = course[0];
        courseData.skuInfo = skuInfo;
        courseData.skuInfo.skuName = skuName;
        courseData.selected = true;
        this.defaultCourseInfo = courseData;
      }

      this.getPrice();
    },
    async init() {
      const { categoryIdList, fullFitScope, productIdList } = this.activityData;
      /*
       * @param {int} allProductStatus 1 所有产品 分页接口 2 限定产品 3限定分类 分页
       * @param {array} categoryIdList 分类id列表
       * @param {int} pageNum , pageSize
       * @param {array} productIdList
       * */
      let page;
      if (fullFitScope === 2) {
        page = {};
      } else {
        page = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        };
      }
      const param = {
        productType: fullFitScope,
        categoryIdList,
        productIdList,
        ...page,
      };
      const res = await reqProductRecommend(param);
      this.loading = false;
      if (res.code === 0) {
        this.pageNum += 1;
        if (!res.data.pages || this.pageNum >= res.data.pages) {
          this.finished = true;
        }
        // 过滤当前选择的课程
        const arr = res.data.data.filter(
          (item) => item.productId !== this.defaultSelectCourse[0].productId,
        );
        if (fullFitScope === 2) {
          this.courseList = arr;
        } else {
          this.courseList = this.courseList.concat(arr);
        }
      }
    },
    close() {
      this.show = false;
    },
    // 价格小数位
    calculationPrice(price) {
      return priceCount(price);
    },
    // 接收sku，将sku存入对应的课程中
    receiveSku(data, way) {
      if (data.productId === this.defaultCourseInfo.productId) {
        this.$set(this.defaultCourseInfo, 'skuInfo', data);
      } else {
        const index = this.courseList.findIndex((sku) => sku.productId === data.productId);
        if (index >= 0) {
          this.$set(this.courseList[index], 'skuInfo', data);
        }
      }
      if (way === 'click') {
        this.getPrice();
      }
    },
    // 接收Card组件选中或取消的课程
    receiveCourse(course, checked) {
      this.courseList.forEach((item) => {
        const temp = item;
        if (item.productId === course.productId && checked) {
          temp.selected = true;
        }
        if (item.productId === course.productId && !checked) {
          temp.selected = false;
        }
      });
      this.getPrice();
    },
    // 联报计价,返回优惠后的金额
    async getPrice() {
      // 已选中的课程
      const coureList = [];
      // 插入默认课程的数据
      coureList.push({
        productId: this.defaultSelectCourse[0].productId,
        skuId: this.defaultCourseInfo.skuInfo?.productSkuId || this.productSku.productSkuId,
      });
      this.courseList.forEach((item) => {
        if (item.selected) {
          coureList.push({
            productId: item.productId,
            skuId: item.skuInfo.productSkuId,
          });
        }
      });
      this.priceLoading = true;
      // req
      const res = await reqPrice({
        promotionBasicPrice: {
          endPoint: 1,
          platform: 2,
        },
        promotionProductSkuPriceList: coureList,
      });
      setTimeout(() => {
        this.priceLoading = false;
      }, 500);
      if (res.code === 0) {
        this.gioList = res.data;
        const {
          productCalculateResultRespList,
          orderPayPrice,
          unionDiscountPrice,
          fullDiscountPrice,
        } = res.data;
        this.totalPrice = orderPayPrice;
        this.unionDiscountPrice = unionDiscountPrice;
        this.selectCourse = productCalculateResultRespList;
        this.fullDiscountPrice = fullDiscountPrice;

        productCalculateResultRespList.forEach((item) => {
          if (this.defaultCourseInfo.productId === item.productId) {
            this.defaultCourseInfo.currPrice = item.currPrice;
          }
          this.courseList.forEach((listItem) => {
            if (listItem.productId === item.productId) {
              // eslint-disable-next-line no-param-reassign
              listItem.currPrice = item.currPrice;
            }
          });
        });
        const skillList = res.data.singleCalculateResultRespList
          ? res.data.singleCalculateResultRespList
          : null;
        if (skillList) {
          // eslint-disable-next-line
          skillList.some(item => {
            if (item.promotionLabel === 2 || item.promotionLabel === 3) {
              this.skillFlag = true;
              return true; // 跳出循环
            }
            this.skillFlag = false;
          });
        } else {
          this.skillFlag = false;
        }
      }
    },
    // 订单
    jumpBuy() {
      /**
       * 区分app
       * 校验登录
       */
      const { isApp = false } = this.$root.$data;
      if (this.userInfo.id) {
        this.jumpPayOrder();
      } else if (isApp) {
        this.$sendToApp('login', {}, true).then(async () => {
          setTokenFromCookie();
          await this.$root.getUserInfo();
          this.jumpPayOrder();
        });
      } else {
        const param = this.selectCourse.map((product) => ({
          productId: product.productId,
          skuId: product.skuId,
        }));
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: '/payOrder', product: JSON.stringify(param) },
        });
      }
    },
    jumpPayOrder() {
      const query = this.selectCourse.map((product) => ({
        productId: product.productId,
        skuId: product.skuId,
      }));
      if (this.$router?.currentRoute?.path.includes('/payOrder')) {
        this.$emit('unionConfirm', query);
        return;
      }
      const { liveRoomId } = this.$route.query;
      if (this.$root.$data.isApp) {
        this.$sendToApp('buyCourseNew', { product: JSON.stringify(query), liveRoomId }, false);
        this.gioDefault();
        return;
      }
      this.$router.push({
        path: 'payOrder',
        query: {
          product: JSON.stringify(query),
          liveRoomId,
        },
      });
      this.gioDefault();
    },
    async gioDefault() {
      const courseIdList = []; const courseNameList = [];
      const allianceId = []; const allianceName = [];
      const fullReductionId = []; const fullReductionName = [];
      const secondsKillNameList = [];
      const {
        orderPayPrice,
        orderTotalPrice,
        productCalculateResultRespList,
        fullDiscountPrice,
        unionDiscountPrice,
        unionCalculateResultRespList,
        promotionFullCalculateResultRespList,
        singleCalculateResultRespList,
      } = this.gioList;
      productCalculateResultRespList.forEach((element) => {
        courseIdList.push(element.productId);
        courseNameList.push(element.productName);
      });
      if (unionDiscountPrice) {
        unionCalculateResultRespList.forEach((element) => {
          allianceId.push(element.promotionId);
          allianceName.push(element.promotionName);
        });
      }
      if (fullDiscountPrice) {
        promotionFullCalculateResultRespList.forEach((element) => {
          fullReductionId.push(element.promotionId);
          fullReductionName.push(element.promotionName);
        });
      }
      if (singleCalculateResultRespList) {
        singleCalculateResultRespList.forEach((element) => {
          if (element.promotionLabel === 2 || element.promotionLabel === 3) {
            secondsKillNameList.push(element.promotionName);
          }
        });
      }
      // 立即购买埋点
      // eslint-disable-next-line
        gio('track', 'buyCourse_event', {
        courseIdList_var: courseIdList.toString(), // 课程 ID 列表
        courseNameList_var: courseNameList.toString(), // 课程名称列表
        courseTotalPrice_var: secondsKillNameList.length > 0 ? orderPayPrice : orderTotalPrice, // 课程总价
        isAlliance_var: unionDiscountPrice ? '是' : '否', // 是否参加联报
        allianceId_var: unionDiscountPrice ? allianceId.toString() : null, // 联报活动ID
        allianceName_var: unionDiscountPrice ? allianceName.toString() : null, // 联报活动名称
        allianceDiscountAmount_var: unionDiscountPrice || null, // 联报优惠金额
        isSecondsKill_var: secondsKillNameList.length > 0 ? '是' : '否', // 是否参加秒杀
        secondsKillNameList_var: secondsKillNameList.length > 0 ? secondsKillNameList.toString() : null, // 秒杀活动名称列表
        isFullReduction_var: fullDiscountPrice ? '是' : '否', // 是否参加满减
        fullReductionId_var: fullDiscountPrice ? fullReductionId.toString() : null, // 满减活动ID
        fullReductionName_var: fullDiscountPrice ? fullReductionName.toString() : null, // 满减活动名称
        fullReductionAmount_var: fullDiscountPrice || null, // 满减优惠金额
        platform_var: gioPlatform(),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.full-reduction-component {
  width: 100%;
  height: 100%;
}
.van-popup {
  background: #f9f9f9;
}
.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 200;
  width: 100%;
  height: 192px;
  background: #fff;

  .foot_discount_info {
    // padding: 0 36px;
    box-sizing: border-box;
    width: 100%;
    height: 72px;
    overflow: hidden;
    background: #fff0e6;

    p {
      width: 678px;
      margin: 0 auto;
      overflow: hidden;
      color: #ff6c02;
      font-size: 22px;
      line-height: 72px;
      white-space: nowrap;
      text-align: center;
      text-overflow: ellipsis;
    }
    .discount_content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      line-height: 72px;
      text-align: center;

      span {
        color: #787878;
        font-size: 25px;
      }
      b {
        color: #ff6c02;
        font-size: 25px;
      }
    }
  }
  .foot_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 120px;
    padding: 0 36px;
    background: #fff;
    .foot_btn_left {
      .num {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-top: 5px;
        p {
          color: #787878;
          font-size: 22px;
        }
        b {
          color: #ff6c02;
          font-weight: 400;
          font-size: 22px;
        }
        span {
          color: #787878;
          font-size: 22px;
        }
        div {
          font-size: 22px;
        }
        .secondSKillTips {
          margin-left: 12px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
        }
      }
      .price {
        display: flex;
        align-items: flex-end;
        width: 100%;
        span {
          color: #ff6e13;
          font-weight: 500;
          font-size: 22px;
          line-height: 30px;
        }
        b {
          color: #ff6e13;
          font-weight: 500;
          font-size: 36px;
          line-height: 40px;
        }
      }
    }
    .foot_btn_right {
      display: flex;
      button {
        width: 235px;
        height: 81px;
        color: #fff;
        font-size: 29px;
        line-height: 81px;
        text-align: center;
        background: #ff6c02;
        border: none;
        border-radius: 44px;
      }
    }
  }
}

.foot-no-discount {
  height: 120px;

  .foot_discount_info {
    display: none;
  }
}
.jointPreferencesDetail {
  padding: 60px 0 220px 0;
  background: #f9f9f9;
  .title {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    background: #f9f9f9;
    .title-text {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 43px 34px;

      img {
        width: 36px;
        height: 36px;
      }

      span {
        color: #000;
        font-weight: 500;
        font-size: 36px;
        text-align: center;
      }
    }
  }
  .course_info {
    padding: 43px 36px 0 36px;
    .course_info_title {
      padding: 36px 0 21px 0;
      color: #333;
      font-weight: 500;
      font-size: 33px;
    }
    .discount_info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 14px 36px;
      background: #fff1e6;
      border-radius: 14px;
      .discount-text {
        color: #ff6c02;
        font-size: 22px;
        line-height: 31px;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
    .course_list {
      .course_list_box {
        .course_list_box_title {
          display: flex;
          align-items: center;
          margin-top: 36px;

          span {
            display: inline-block;
            width: 5px;
            height: 25px;
            background: #ff6c02;
            border-radius: 3px;
          }
          b {
            padding-left: 8px;
            color: #333;
            font-weight: 500;
            font-size: 29px;
          }
        }
      }
    }
  }
}
::v-deep .defaultSelectCourse {
  .jointPreferencesCard .check {
    display: none;
  }
  .jointPreferencesCard {
    .right_price,
    .times {
      pointer-events: none;
    }
  }
}
</style>
